"use client";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import SectionHeader from "./SectionHeader";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";

function stripEmptyClassAttributes(html) {
  if (!html || typeof html !== "string") return html;
  return html.replace(/\sclass\s*=\s*["']["']/gi, "");
}

export default function ExpandableTextSection({
  title,
  text,
  showHeader = true,
}) {
  const t = useTranslationDetector();
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const textRef = useRef(null);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  // Text prop'unu işle - array ise ShowContent: true olanları birleştir
  const processedText = () => {
    if (Array.isArray(text)) {
      const filteredTexts = text
        .filter((item) => item.ShowContent === true)
        .map((item) => item.Text);

      if (filteredTexts.length === 0) return "";
      if (filteredTexts.length === 1) return filteredTexts[0];

      // Her text'i ayrı paragraf olarak sarmalayıp birleştir
      return `<p>${filteredTexts.join("</p><p>")}</p>`;
    }
    return text;
  };

  const htmlForDisplay = stripEmptyClassAttributes(processedText());

  useEffect(() => {
    if (textRef.current) {
      // Metin yüksekliğini ölç
      const textHeight = textRef.current.scrollHeight;
      // Eğer metin 220px'den kısaysa butonu gizle
      setShowButton(textHeight > 220);
    }
  }, [text]);

  return (
    <div className="flex flex-col gap-6 overflow-hidden">
      <div className="flex flex-col gap-4 md:gap-6">
        {showHeader && <SectionHeader title={title} />}
        <div
          className={clsx(
            "overflow-hidden transition-all duration-500",
            expanded ? "max-h-[3000px]" : "max-h-[220px]",
          )}
        >
          <div
            ref={textRef}
            className="text-foreground space-y-6 [&_h1,&_h2,&_h3,&_h4,&_h5,&_h6]:text-xl [&_h1_strong,&_h2_strong,&_h3_strong,&_h4_strong,&_h5_strong,&_h6_strong]:font-medium"
            dangerouslySetInnerHTML={{ __html: htmlForDisplay }}
          />
        </div>
      </div>
      {showButton && (
        <button
          onClick={toggleExpand}
          className="text-primary flex cursor-pointer items-center justify-center gap-2 text-lg font-medium"
        >
          <span>{!expanded ? t("common.showMore") : t("common.showLess")}</span>
          <div className="flex h-full items-center justify-center">
            {" "}
            <FontAwesomeIcon
              icon={byPrefixAndName.far["chevron-down"]}
              className={clsx(
                "transition-transform duration-300 !w-6 !h-6",
                expanded ? "rotate-180" : "",
              )}
            />
          </div>
        </button>
      )}
    </div>
  );
}
